import styled from "@emotion/styled";
import React from "react";

type Props = {
  subTitle: string;
  title: string;
};

export default function RaffleHeading(props: Props) {
  return (
    <>
      <SubHeading>{props.subTitle}</SubHeading>
      <Heading>{props.title}</Heading>
    </>
  );
}

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 800;
  text-align: center;
  margin: 12px 0;
  color: var(--tw-gray-800);
`;

const SubHeading = styled.h3`
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 12px 0;
`;
